import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import { Box, Container } from "@mui/system";
import ExperiencesFilters from "./ExperiencesFilters";
import { Grid, Pagination, Skeleton, Typography } from "@mui/material";
import ExperienceCard from "./ExperienceCard";
import PartnersCarousel from "../../reusable/PartnersCarousel";
import RandomTestimonial from "../../reusable/RandomTestimonial";
import Accreditations from "../../reusable/fieldGroups/Accreditations";

export default function Experiences() {

  const [pageData, setPageData] = useState();

  //Fetch posts page
  const { isPending, isError, data, error } = useQuery(
    ["posts-page"], //Query key
    () =>
      axios({
        //Query function
        method: "get",
        url:
          WP_API_Settings.endpoint +
          "wp/v2/pages?slug=experience&_embed=true&acf_format=standard",
      })
  );

  useEffect(() => {
    if (data?.data) {
      setPageData(data.data[0]);
    }
  }, [data]);

  //console.log(pageData)

  //Track states for posts
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [filter, setFilter] = useState();
  const [search, setSearch] = useState();

  //Fetch posts
  useEffect(() => {
    setLoading(true);
    let query =
      WP_API_Settings.endpoint +
      "wp/v2/theme_experience" +
      "?orderby=date" +
      "&order=asc" +
      "&page=" +
      page +
      "&per_page=4" +
      "&_embed=true" +
      "&acf_format=standard";
    if (filter) {
      query += "&filter=" + filter;
    }
    if (search) {
      query += "&search=" + search;
    }
    query += "&_embed=true";
    axios.get(query).then((response) => {
      //console.log(response)
      if (response.data) {
        setPosts(response.data);
      }
      setTotalPages(response.headers["x-wp-totalpages"]);
      setLoading(false);
    });
  }, [page, filter, search]);

  //Back to page 1 on filter change
  useEffect(() => {
    setPage(1);
  }, [filter]);

  return (
    <>
      <GlobalMeta />
      <InternalBanner
        featuredImage={
          pageData?._embedded?.["wp:featuredmedia"]?.[0]?.source_url
        }
        banner={pageData?.acf.internal_banner}
        isPosts
      />
      <Container maxWidth="xl">
        {loading ? (
          <Skeleton
            variant="rectangular"
            height={35}
            sx={{
              marginTop: "40px",
            }}
          />
        ) : (
          <Typography
            variant="h3"
            component="h3"
            sx={{
              color: "#265DA5",
              marginTop: "40px",
              marginBottom: "40px",
            }}
          >
            {pageData?.acf.experiences.intro}
          </Typography>
        )}
        {/* <ExperiencesFilters
                    page={page}
                    totalPages={totalPages}
                    setCategory={setFilter}
                    setSearchText={setSearch}
                /> */}
        <Grid container spacing={4}>
          {loading ? (
            Array(perPage)
              .fill(0)
              .map(() => {
                return (
                  <Grid item xs={12} md={6}>
                    <Skeleton variant="rectangular" height={400} />
                  </Grid>
                );
              })
          ) : posts.length ? (
            posts.map((post, i) => {
              return (
                <Grid item xs={12} md={6}>
                  <ExperienceCard post={post} index={i} />
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Typography
                variant="h3"
                component="p"
                sx={{
                  textAlign: "center",
                  color: "#005EAA",
                }}
              >
                No Experiences found
              </Typography>
            </Grid>
          )}
          {posts && posts.length ? (
            <Grid item xs={12}>
              <Box
                sx={{
                  width: "fit-content",
                  m: "auto",
                }}
              >
                <Pagination
                  size="large"
                  color="primary"
                  count={totalPages}
                  page={page}
                  onChange={(event, value) => {
                    setPage(value);
                  }}
                />
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </Container>
      <Box sx={{ height: "100px" }} />
      <PartnersCarousel />
      <RandomTestimonial
        testimonials={pageData?.acf.testimonials}
        loading={loading}
      />
      <Box sx={{ height: "40px" }} />
      <Accreditations
        accreditations={pageData?.acf.accreditations}
        loading={loading}
      />
      <Box sx={{ height: "60px" }} />
    </>
  );
}

